//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { FacebookOnboardingActions } from '@facebook/actions/facebookOnboardingActions';
import { FACEBOOK_ONBOARDING_ACTIONS } from '@facebook/constants/facebookConstants';
import { IFacebookOnboarding } from '@facebook/models/facebookStateModel';

const initialState: IFacebookOnboarding = {
  availableFacebookPages: {
    byId: {},
    orderedIds: []
  },
  ignoreDifferentPage: false,
  onboardingCarouselStep: 0,
  onboardingConfirmPage: false,
  onboardingSelectedPageId: undefined,
  flags: {
    isFetchingAvailableFacebookPages: false,
    isUpdatingConnectedPage: false,
  },
};

export default function FacebookOnboardingReducer(
  state: IFacebookOnboarding = initialState,
  action: FacebookOnboardingActions,
): IFacebookOnboarding {
  switch (action.type) {
    case FACEBOOK_ONBOARDING_ACTIONS.UPDATE_ONBOARDING_SELECTED_PAGE_ID: {
      return {
        ...state,
        onboardingSelectedPageId: action.onboardingSelectedPageId,
      };
    }
    case FACEBOOK_ONBOARDING_ACTIONS.REQUEST_UPDATE_CONNECTED_PAGE: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isUpdatingConnectedPage: true,
        },
      };
    }
    case FACEBOOK_ONBOARDING_ACTIONS.RECEIVE_UPDATE_CONNECTED_PAGE_SUCCEEDED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isUpdatingConnectedPage: false,
        },
      };
    }
    case FACEBOOK_ONBOARDING_ACTIONS.REQUEST_AVAILABLE_PAGES: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isFetchingAvailableFacebookPages: true,
        },
        availableFacebookPages: initialState.availableFacebookPages,
      };
    }
    case FACEBOOK_ONBOARDING_ACTIONS.RECEIVE_AVAILABLE_PAGES_SUCCEEDED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isFetchingAvailableFacebookPages: false,
        },
        availableFacebookPages: action.availablePages,
      };
    }
    case FACEBOOK_ONBOARDING_ACTIONS.RECEIVE_AVAILABLE_PAGES_FAILED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isFetchingAvailableFacebookPages: false,
        },
      };
    }
    case FACEBOOK_ONBOARDING_ACTIONS.UPDATE_ONBOARDING_CAROUSEL_STEP: {
      return {
        ...state,
        onboardingCarouselStep: action.onboardingCarouselStep,
      };
    }
    case FACEBOOK_ONBOARDING_ACTIONS.UPDATE_IGNORE_DIFFERENT_PAGE: {
      return {
        ...state,
        ignoreDifferentPage: action.ignoreDifferentPage,
      };
    }
    case FACEBOOK_ONBOARDING_ACTIONS.UPDATE_ONBOARDING_CONFIRM_PAGE: {
      return {
        ...state,
        onboardingConfirmPage: action.onboardingConfirmPage,
      };
    }
    default:
      return state;
  }
}
